import {ru} from "./location/ru";
import {us} from "./location/us";

export const translationsObject = {
    ru: {...ru},
    us: {...us},
};
